import React from 'react';
import type { AvatarProps } from '@mui/material';
import { Avatar as MuiAvatar } from '@mui/material';

type Props = AvatarProps;

const Avatar: React.FC<Props> = ({ sx, ...props }) => (
    <MuiAvatar sx={{ bgcolor: 'primary.main', ...sx }} {...props} />
);

export default Avatar;
